import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { buildApiUrl } from "../config/api.config";
import AIBackgroundEffects from "./AIBackgroundEffects";
import "./PaymentSuccess.css";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [error, setError] = useState(null);

  // Los parámetros que Wompi envía pueden variar
  const reference = searchParams.get("reference") || searchParams.get("identificadorEnlaceComercio");
  const status = searchParams.get("status") || searchParams.get("estado");

  useEffect(() => {
    console.log("🚀 PaymentSuccess montado");
    console.log("📋 Parámetros URL:", {
      reference,
      status,
      allParams: Object.fromEntries(searchParams)
    });

    if (reference) {
      verifyPayment();
    } else {
      console.error("❌ No se encontró referencia de pago");
      setError("No se encontró referencia de pago");
      setLoading(false);
    }
  }, [reference]);

  const verifyPayment = async () => {
    try {
      console.log("🔍 Verificando pago con referencia:", reference);
      console.log("🌐 URL completa:", buildApiUrl(`/api/payments/status/${reference}`));

      const response = await axios.get(
        buildApiUrl(`/api/payments/status/${reference}`)
      );

      console.log("✅ Respuesta recibida:", response.data);

      if (response.data.success) {
        setPaymentStatus(response.data.data);
      } else {
        setError("No se pudo verificar el pago");
      }
    } catch (err) {
      console.error("❌ Error verificando pago:", err);
      console.error("Detalles del error:", err.response?.data);
      setError(err.response?.data?.message || "Error al verificar el estado del pago");
    } finally {
      setLoading(false);
    }
  };

  const handleGoToSuccess = () => {
    if (paymentStatus) {
      navigate("/success", {
        state: {
          subscriptionId: paymentStatus.subscriptionId,
          email: paymentStatus.email,
          businessName: paymentStatus.businessName,
        },
      });
    }
  };

  if (loading) {
    return (
      <div className="payment-success-container">
        <AIBackgroundEffects step={3} />
        <div className="payment-success-card">
          <div className="loading-spinner-large"></div>
          <h2>Verificando tu pago...</h2>
          <p>Por favor espera un momento</p>
        </div>
      </div>
    );
  }

  if (error || !paymentStatus) {
    return (
      <div className="payment-success-container">
        <AIBackgroundEffects step={3} />
        <div className="payment-success-card error-card">
          <div className="error-icon">❌</div>
          <h2>Error al Verificar Pago</h2>
          <p>{error || "No se pudo obtener información del pago"}</p>
          <button onClick={() => navigate("/")} className="btn-primary">
            Volver al Inicio
          </button>
        </div>
      </div>
    );
  }

  const isPaid = paymentStatus.status === "paid";

  return (
    <div className="payment-success-container">
      <AIBackgroundEffects step={3} />
      <div className={`payment-success-card ${isPaid ? "success-card" : "pending-card"}`}>
        <div className={`status-icon ${isPaid ? "success-icon" : "pending-icon"}`}>
          {isPaid ? "✓" : "⏳"}
        </div>

        <h1>{isPaid ? "¡Pago Exitoso!" : "Pago Pendiente"}</h1>

        <p className="status-message">
          {isPaid
            ? "Tu pago ha sido procesado correctamente"
            : "Tu pago está siendo procesado"}
        </p>

        <div className="payment-details">
          <div className="detail-row">
            <span className="detail-label">Negocio:</span>
            <span className="detail-value">{paymentStatus.businessName}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Email:</span>
            <span className="detail-value">{paymentStatus.email}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Monto:</span>
            <span className="detail-value amount">${paymentStatus.amount}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Estado:</span>
            <span className={`detail-value status-badge ${paymentStatus.status}`}>
              {paymentStatus.status === "paid" ? "Pagado" : "Pendiente"}
            </span>
          </div>
          {paymentStatus.paidAt && (
            <div className="detail-row">
              <span className="detail-label">Fecha de Pago:</span>
              <span className="detail-value">
                {new Date(paymentStatus.paidAt).toLocaleString("es-ES")}
              </span>
            </div>
          )}
        </div>

        {isPaid && (
          <div className="next-steps">
            <h3>🎉 ¡Siguiente Paso!</h3>
            <p>
              Tu agente de voz IA está siendo creado. Haz clic abajo para ver el
              estado de tu agente.
            </p>
          </div>
        )}

        <div className="action-buttons">
          {isPaid ? (
            <button onClick={handleGoToSuccess} className="btn-primary">
              Ver Estado del Agente →
            </button>
          ) : (
            <button onClick={verifyPayment} className="btn-secondary">
              Verificar de Nuevo
            </button>
          )}
          <button onClick={() => navigate("/")} className="btn-outline">
            Volver al Inicio
          </button>
        </div>

        <div className="footer-note">
          <p>
            ¿Tienes preguntas? Contáctanos en{" "}
            <a href="mailto:support@aivoiceagent.com">support@aivoiceagent.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
